module.exports = __webpack_public_path__ + "static/mittelberger@2x.af897c2b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/avatars/mittelberger@2x.jpg
// module id = 150
// module chunks = 35783957827783 263791100135453